import * as React from 'react'

const Start = (props) => {
  const { color } = props
  return (
    <svg viewBox='0 0 22 28' width='18' height='14.4' fill={color || 'gold'}>
      <g>
        <path d='M12.56,0.11l-3.88,7.86l-8.68,1.26l6.28,6.12l-1.48,8.64l7.76,-4.08l7.76,4.08l-1.48,-8.64l6.28,-6.12l-8.68,-1.26z' />
      </g>
    </svg>
  )
}

export default Start



// WEBPACK FOOTER //
// ./src/components/atoms/configurator/Star.tsx